import { ThemeProvider, createTheme } from '@mui/material/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// HOCs
// Components
import AppLoader from './app/components/loaders/AppLoader';
import LoginComponent from './app/containers/login/Login';
// import LoaderComponent from "./app/components/other/LoaderComponent";

import AdminLayoutAsync from './app/containers/admin/layout/Layout';
import { LOCAL_STORAGE_KEYS } from './global/const';

export const PrivateRoute = ({ children }) => {
  if (localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN) === null) {
    //Not signed in

    return <Navigate to="/" />;
  }
  //Signed in
  return children;
};

const AppRoutes = () => {
  const loader = useSelector((state) => state.loading);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#3f51b5',
      },
      secondary: {
        main: '#f50057',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            padding: '5px',
            letterSpacing: 'normal',
          },
        },
      },
    },
  });

  return (
    <div>
      {loader.isLoading && <AppLoader title={loader.title} />}
      <BrowserRouter>
        <Routes>
          <Route path={'/'} element={<LoginComponent />} />
          <Route
            path={'/admin/*'}
            element={
              <PrivateRoute>
                <ThemeProvider theme={theme}>
                  <AdminLayoutAsync />
                </ThemeProvider>
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <ToastContainer autoClose={4000} position="bottom-center" closeOnClick={true} hideProgressBar={true} />
    </div>
  );
};

export default AppRoutes;
